import {
  gtmFleekListingProductImpressions,
  gtmPromotionCmsImpressions,
  gtmPromotionPdpImpressions,
  gtmListingProductImpressions,
  luxeGtmProductImpressions,
  segmentDatalayerPushData
} from '../../modules/ga/GTMdatalayer';
import { FLEEK_STORE } from '../../constants/constant';
import {fireOsmosPlpImpression} from '../../utils/osmosPlpImpressionUtils';
export const setFeedImpressionPromoId = (promoId = '', localVariable = '') => {
  const getLocalData = JSON.parse(sessionStorage.getItem(localVariable)) || [];
  if (getLocalData?.indexOf(promoId) === -1) {
    getLocalData?.push(promoId);
    sessionStorage.setItem(localVariable, JSON.stringify(getLocalData));
  }
};

export const getBundleFeedImpressionArray = (localVariable = '', includeData = false) => {
  let data = JSON.parse(sessionStorage.getItem(localVariable)) || {};
  return includeData ? data : data?.promotionArray || [];
};

export const checkFeedImpressionPromoId = (promoId = '', localVariable = '') => {
  const getLocalData = JSON.parse(sessionStorage.getItem(localVariable)) || [];
  const response = getLocalData?.indexOf(promoId) !== -1;
  return response;
};

export const setBundleFeedImpressionArray = (
  localVariable = '',
  promotionArray = [],
  promotionData = {}
) => {
  let getLocalData = JSON.parse(sessionStorage.getItem(localVariable)) || {};
  getLocalData = {
    ...getLocalData,
    promotionArray: promotionArray,
    promotionData: promotionData
  };
  sessionStorage.setItem(localVariable, JSON.stringify(getLocalData));
};

export const emptyBundleFeedImpressionArray = (localVariable = '') => {
  sessionStorage.removeItem(localVariable);
};

export const handleGaEventsforFeedComponents = (
  localVariableForBundle,
  localVariableForImpressions,
  item,
  storeType,
  pageName,
  pageType,
  customId = '',
  isForproduct = false,
  storyId = '',
  postId = ''
) => {
  let promotionArray = getBundleFeedImpressionArray(localVariableForBundle); // Get the bundled data
  let isPromoIdExists = checkFeedImpressionPromoId(
    customId ? customId : item?.id,
    localVariableForImpressions
  ); // check if data has already made any impressions or not
  if (!isPromoIdExists) {
    promotionArray.push(item);
    setBundleFeedImpressionArray(localVariableForBundle, promotionArray, {
      storeType,
      pageName,
      pageType
    }); // Add data to the bundle
  }
  if (promotionArray.length === 5) {
    // Fire the impression when bundle length reaches 5 and empty the bundle array
    if (isForproduct) {
      gtmFleekListingProductImpressions(
        {
          ...promotionArray
        },
        FLEEK_STORE.toLowerCase(),
        pageName ? pageName : 'story screen',
        pageType ? pageType : 'story screen',
        postId,
        storyId
      );
    } else {
      gtmPromotionCmsImpressions(promotionArray, storeType, pageName, pageType);
    }
    emptyBundleFeedImpressionArray(localVariableForBundle);
  }
  // Add data to impressions array
  setFeedImpressionPromoId(customId ? customId : item?.id, localVariableForImpressions);
};

export const handleGaEventsforPDPComponents = (
  localVariableForBundle,
  localVariableForImpressions,
  item,
  productData,
  storeType,
  pageName,
  pageType,
  customId = ''
) => {
  let promotionArray = getBundleFeedImpressionArray(localVariableForBundle); // Get the bundled data
  let isPromoIdExists = checkFeedImpressionPromoId(
    customId ? customId : item?.id,
    localVariableForImpressions
  ); // check if data has already made any impressions or not
  if (!isPromoIdExists) {
    promotionArray.push(item);
    setBundleFeedImpressionArray(localVariableForBundle, promotionArray, {
      storeType,
      ...productData,
      pageName
    }); // Add data to the bundle
  }
  if (promotionArray.length === 5) {
    // Fire the impression when bundle length reaches 5 and empty the bundle array
    gtmPromotionPdpImpressions(promotionArray, storeType, productData, '');
    emptyBundleFeedImpressionArray(localVariableForBundle);
  }
  // Add data to impressions array
  setFeedImpressionPromoId(item?.id, localVariableForImpressions);
};

export const handleWindowUnload = (localVariable, isForproduct = false, storyId='', postId ='') => {
  let { promotionArray = [], promotionData = {} } =
    getBundleFeedImpressionArray(localVariable, true) || {};
  if (promotionArray?.length > 0) {
    const { storeType, pageName, pageType } = promotionData;
    if (isForproduct) {
      gtmFleekListingProductImpressions(
        {
          ...promotionArray
        },
        FLEEK_STORE.toLowerCase(),
        pageName ? pageName : 'story screen',
        pageType ? pageType : 'story screen',
        postId,
        storyId
      );
    } else {
      gtmPromotionCmsImpressions(promotionArray, storeType, pageName, pageType);
    }
    sessionStorage.removeItem(localVariable);
  }
};

export const handleProductImpressionsForDynamicWidget = (
  localVariableForBundle,
  localVariableForImpressions,
  item,
  storeType,
  pageName,
  pageType,
  customId = '',
  containsLuxe = false,
  fireLuxeImpressions = false,
  ProductArray = []
) => {
  const promotionArray = getBundleFeedImpressionArray(localVariableForBundle); // Get the bundled data
  const isPromoIdExists = checkFeedImpressionPromoId(
    customId || item?.id,
    localVariableForImpressions
  ); // check if data has already made any impressions or not

  if (!isPromoIdExists) {
    promotionArray.push(item);
    setBundleFeedImpressionArray(localVariableForBundle, promotionArray, {
      storeType,
      pageName,
      pageType
    }); // Add data to the bundle
  }
  if (promotionArray.length === 5) {
    // Fire the impression when bundle length reaches 5 and empty the bundle array
    if (fireLuxeImpressions) {
      luxeGtmProductImpressions({
        impressions: promotionArray,
        store_type: storeType,
        page_name: pageName,
        page_type: pageType,
        contains_luxe: containsLuxe,
        ProductArray
      });
    }
    gtmListingProductImpressions({
      promotionArray,
      list: 'landing screen',
      store_type: storeType,
      page_name: pageName,
      page_type: pageType,
      contains_luxe: containsLuxe
      },
      '',
      '',
      '',
      '',
      '',
      pageName
    );

    emptyBundleFeedImpressionArray(localVariableForBundle);
  }
  // Add data to impressions array
  setFeedImpressionPromoId(customId || item?.id, localVariableForImpressions);
};

export const handleWindowUnloadForDynamicWidgetProductImpressions = (
  localVariable,
  containsLuxe
) => {
  const { promotionArray = [], promotionData = {} } =
    getBundleFeedImpressionArray(localVariable, true) || {};
  if (promotionArray?.length > 0) {
    const { storeType, pageName, pageType } = promotionData;
    gtmListingProductImpressions({
      promotionArray,
      list: 'landing screen',
      store_type: storeType,
      page_name: pageName,
      page_type: pageType,
      contains_luxe: containsLuxe
    });
    sessionStorage.removeItem(localVariable);
  }
};

export const handleSegmentEventsForJioAds = (
  localVariableForBundle,
  localVariableForImpressions,
  item,
  storeType,
  pageName,
  pageType,
  parentProductObj,
  uclid,
  index
) => {
  let promotionArray = getBundleFeedImpressionArray(localVariableForBundle); // Get the bundled data
  let isPromoIdExists = checkFeedImpressionPromoId(
    item?.product_id,
    localVariableForImpressions
  ); // check if data has already made any impressions or not
  if (!isPromoIdExists) {
    promotionArray.push(item);
    setBundleFeedImpressionArray(localVariableForBundle, promotionArray, {
      storeType,
      pageName,
      pageType
    }); // Add data to the bundle
    if(uclid) {
       fireOsmosPlpImpression({
        uclid,
        position: index,
        page: 'PDP'
      })
    }
  }
  if (promotionArray.length === 5) {
    // Fire the impression when bundle length reaches 5 and empty the bundle array
    segmentDatalayerPushData({
      event: 'Product Viewed',
      ecommerce: { items: [ ...promotionArray ] },
      impression_source: 'jioads_pdp_widget',
      impression_type: uclid ? 'osmos_pdp_widget' : 'jioads_pdp_widget',
      ...parentProductObj
    });
    emptyBundleFeedImpressionArray(localVariableForBundle);
  }
  // Add data to impressions array
  setFeedImpressionPromoId(item?.product_id, localVariableForImpressions);
};

export const handleWindowUnloadForSegment = (localVariable) => {
  let { promotionArray = [], promotionData = {} } =
    getBundleFeedImpressionArray(localVariable, true) || {};
  if (promotionArray?.length > 0) {
    const { storeType, pageName, pageType } = promotionData;
     segmentDatalayerPushData({
      event: 'Product Viewed',
      ecommerce: { items: [ ...promotionArray ] },
      impression_source: 'jioads_pdp_widget',
      impression_type: 'jioads_pdp_widget'
    });
    sessionStorage.removeItem(localVariable);
  }
};